import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams } from "../http-params.util";

/**
 * LoggerApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/loggerApi/loggerApi.service.js.
 *
 * Legacy `/v1/api/logger/log` is rewritten to `/v2/` via ApiVersionFactory.
 * Hardcoded here.
 *
 * Bug fix: the legacy `log()` referenced an undeclared `q` variable when
 * `props` was falsy (hoisting saved it to `undefined`, which then got
 * concatenated into the URL as the string `"undefined"`). With buildParams,
 * an absent `props` simply produces an empty querystring.
 */
const LOGGER_LOG_BASE_V2 = "/v2/api/logger/log";
const LOG_FIELDS = ["sendEmail"] as const;

@Injectable({ providedIn: "root" })
export class LoggerApiService {
  private readonly http = inject(HttpClient);

  log(props?: Record<string, unknown>): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.post<unknown>(LOGGER_LOG_BASE_V2, props ?? {}, {
        params: buildParams(props, LOG_FIELDS),
      }),
    );
  }
}
